import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useCustomerEnrichApiKeyCreate } from 'features/customers/hooks/useCustomerEnrichApiKeyCreate'
import { ENRICH_API_LIMIT_LABELS } from 'features/customers/utils/features'

import { FormTextField } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { parseDomainAllowlistInput } from 'validators/domain-allowlist'

const config = [
  {
    title: ENRICH_API_LIMIT_LABELS.enrichApiRequestsLimit,
    render: () => <FormTextField name="quota" type="number" />,
  },
  {
    title: 'Domain Allowlist',
    render: () => <FormTextField name="publicApiKeyDomainAllowlist" placeholder="e.g. example.com, app.example.com" />,
  },
]

type GenerateEnrichApiKeyModalProps = {
  handleSubmit: (...args: any[]) => any
  initialValues: Record<string, any>
  onClose: (...args: any[]) => any
}

const GenerateEnrichApiKeyModal = ({ handleSubmit, onClose, initialValues }: GenerateEnrichApiKeyModalProps) => {
  const { createEnrichApiKey, isPending: isLoading } = useCustomerEnrichApiKeyCreate()

  const onSubmit = async values => {
    await createEnrichApiKey({
      quota: values.quota,
      publicApiKeyDomainAllowlist: parseDomainAllowlistInput(values.publicApiKeyDomainAllowlist),
    })
    onClose()
  }

  return (
    <Dialog onClose={onClose} open>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Generate new key</DialogTitle>
        <DialogContent style={{ width: 500 }}>
          {initialValues.hasKey && (
            <DialogContentText>
              Are you sure? This will require the customer to update their configuration to use the new key instead of
              the old one.
            </DialogContentText>
          )}
          <DescriptionListTable config={config} titleCellStyle={{ width: 200 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="primary" loading={isLoading} type="submit">
            Generate
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'enrichApiCreate' })(GenerateEnrichApiKeyModal)
